import { defineComponent as l, createElementBlock as p, openBlock as c, mergeProps as f, unref as e, createVNode as r, withCtx as u } from "vue";
import d from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Drawer/drawer.js";
import { useOUIAProps as C } from "../../helpers/ouia.js";
import _ from "../Button.vue2.js";
import { XmarkIcon as B } from "../../packages/icons/dist/esm/icons/xmark-icon.js";
const x = /* @__PURE__ */ l({
  name: "PfDrawerCloseButton",
  __name: "DrawerCloseButton",
  props: {
    ariaLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["close"],
  setup(t, { emit: i }) {
    const o = t, n = C({ id: o.ouiaId, safe: o.ouiaSafe }), s = i;
    return (m, a) => (c(), p("div", f(e(n), {
      class: e(d).drawerClose
    }), [
      r(_, {
        variant: "plain",
        "aria-label": m.ariaLabel,
        onClick: a[0] || (a[0] = (b) => s("close"))
      }, {
        icon: u(() => [
          r(e(B))
        ]),
        _: 1
      }, 8, ["aria-label"])
    ], 16));
  }
});
export {
  x as default
};
